import React from 'react';
import { CompassIcon, LayersIcon, MessageSquareQuoteIcon, MusicIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { volumes, type VolumeIcon } from '../data/volumes';
import { Eyebrow } from './Eyebrow';
const icons: Record<VolumeIcon, React.ElementType> = {
  method: CompassIcon,
  rhythm: MusicIcon,
  harmony: LayersIcon,
  language: MessageSquareQuoteIcon,
  improv: SparklesIcon,
  jam: UsersIcon
};
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-398" data-mp="1zt8grwaywnfh">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-399" data-mp="24s1r5fuyjybf">
        <div className="max-w-2xl" data-id="element-400" data-mp="1qtblvcxzisbz">
          <Eyebrow data-id="element-401" data-mp="1qwhays6m5u7p">The complete system</Eyebrow>
          <h2 id="volumes-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-402" data-mp="1vsoiuqiklfsa">
            Six <span className="text-amber" data-id="element-403" data-mp="fhasfkq6efpw">volumes</span>
          </h2>
        </div>

        <ol className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-404" data-mp="kfm1ht8ncm72">
          {volumes.map(volume => {
          const Icon = icons[volume.icon];
          return <li key={volume.number} className="flex flex-col rounded-2xl border border-night-600 bg-night-800 p-6 transition-[box-shadow,border-color] duration-150 ease-out hover:border-amber/50 hover:shadow-[0_12px_32px_rgba(0,0,0,0.35)] sm:p-7" data-id="element-405" data-mp="3jadffgvasu79">
                <div className="flex items-center gap-4" data-id="element-406" data-mp="b0bwcj4b9457">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg" style={{
                backgroundColor: volume.accent
              }} data-id="element-407" data-mp="62tjwir346sg">
                    <Icon className="h-5 w-5 text-cream" aria-hidden="true" data-id="element-408" data-mp="frtnkfgj7qcz" />
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-409" data-mp="trmo12hv1ky5">
                    Vol. {volume.number}
                  </span>
                </div>

                <h3 className="mt-6 font-display text-2xl leading-tight text-cream" data-id="element-410" data-mp="wtzgksc0ocaz">
                  {volume.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-cream-soft" data-id="element-411" data-mp="11tltt1ruhsjs">{volume.description}</p>

                <p className="mt-auto pt-6 text-xs font-semibold leading-relaxed text-cream" data-id="element-412" data-mp="16r59850a4bdb">
                  {volume.contents.join(' · ')}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}